import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TuiAccordion } from '@taiga-ui/experimental';

export interface FaqAccordionItems {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq-accordion',
  imports: [TuiAccordion],
  templateUrl: './faq-accordion.component.html',
  styleUrl: './faq-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqAccordionComponent {
  items = input.required<FaqAccordionItems[]>();
}
